import { SEARCH_MODAL_ITEM_KIND } from '@common/components/SearchModal/search-modal.const'

import type { AcademySearchApiItem } from '@/lib/academySearch/academySearch.interface'
import { getAcademyExternalUrl } from '@/shared/docs-shared.utils'

export function mapGlossary(row: AcademySearchApiItem, _queryTrimmed: string) {
  const academyUrl = getAcademyExternalUrl()
  const href = academyUrl ? `${academyUrl}/glossary#${row.slug}` : `#${row.slug}`

  return {
    id: `glossary-${row.path}`,
    title: row.title,
    href,
    kind: SEARCH_MODAL_ITEM_KIND.Glossary,
  }
}
